import React, { useEffect, useRef, useState } from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import {
  InterviewRoundDetailsType,
  SingleApprovalDataType,
  SingleScheduledUpcomingInterviewsDetailsType,
} from "../../redux/thinksToDo/thinksToDoType";
import { CalenderIcon, PaperClipIcon } from "../Icon";
import {
  formatDate,
  formatDateAndTimeWithoutLocal,
  getTodayDateWithTimeStamp,
  reverseDate,
} from "../../utils/commonFunctions";
import { CircularAvatar, Loader, RadioContainer } from "../commons";
import CustomizedAvatar from "../commons/CircularAvatar/CustomizedAvatar";
import {
  BriefCase,
  CVIcon,
  CollapseClose,
  CollapseOpen,
  EmployeeIcon,
  GroupPeopleIcon,
  IdBadge,
  InterviewStatusIcon,
  LinkdionIcon,
  LoctionRedIcon,
  NoticeCalendarIcon,
  RecruiterHRIcon,
  WalletIcon,
} from "../../assets/images";
import { useLocation } from "react-router-dom";
import { LoginResponseType } from "../../redux/auth/authTypes";
import { useMenuCheck } from "../../customHooks/useMenuCheck";
import { RadioTypes } from "../../commonTypes/universalTypes";
import { connect } from "react-redux";
import { RootState } from "../../redux/rootReducers";
import { getApprovalListAction } from "../../redux/hrms";
import { ApprovalListPayloadType } from "../../commonTypes/hrmsTypes";
import { singleGetApprovalListAction } from "../../redux/thinksToDo";
import { SingleApprovalListPayloadType } from "../../commonTypes/thinksToDoTypes";
import {
  getTokenGenerateForDownloadAction,
  resetSasTokenForDownloadFile,
} from "../../redux/stcoTools";
import { GetGenerateSasTokenPayloadType } from "../../commonTypes/stcoToolsType";
type AppProps = {
  toggle: () => void;
  isOpen: boolean;
  data: SingleScheduledUpcomingInterviewsDetailsType;
  hanldeFeedback?: (data: string) => void;
  handleSubmitFeedback?: () => void;
  loginData: LoginResponseType;
  fetching: boolean;
  isInterviewApproval?: boolean;
  isApproved?: boolean;
  setIsApproved?: React.Dispatch<React.SetStateAction<boolean>>;
  dispatchSingleApprovalListAction: (
    data: SingleApprovalListPayloadType
  ) => void;
  token: string | null;
  approvalId?: string;
  singleApprovalData: SingleApprovalDataType;
  type: string;
  sasTokenForDownloadFile: string;
  dispatchResetSasTokenForDownloadFile: () => void;
  dispatchGetTokenGenerateForDownloadAction: (
    data: GetGenerateSasTokenPayloadType
  ) => void;
};
const RADIO_OPTIONS: RadioTypes[] = [
  {
    id: "3",
    name: "Approve",
  },
  {
    id: "2",
    name: "Reject",
  },
];

const FeedBackModal = ({
  toggle,
  isOpen,
  data,
  hanldeFeedback,
  handleSubmitFeedback,
  loginData,
  fetching,
  isInterviewApproval,
  isApproved,
  setIsApproved,
  dispatchSingleApprovalListAction,
  token,
  approvalId,
  singleApprovalData,
  type,
  dispatchResetSasTokenForDownloadFile,
  dispatchGetTokenGenerateForDownloadAction,
  sasTokenForDownloadFile,
}: AppProps) => {
  let userId = process.env.REACT_APP_OWNER_ID || "[]";
  const ownerID = JSON.parse(userId);
  const approvedUserID = ownerID.find((id: string) => id === String(loginData?.user_id));

  const [feedback, setFeedback] = useState("");
  const [isUpdatePresent, setIsUpdatePresent] = useMenuCheck();
  const [isApprovedRedio, setIsApprovedRedio] = useState<string>(
    RADIO_OPTIONS[0].id
  );
  const [isCandidateCollapsed, setIsCandidateCollapsed] = useState(
    loginData?.user_id == approvedUserID ? true : false
  );
  const [isHiringCollapsed, setIsHiringCollapsed] = useState(false);
  const [
    isChangeApprovalStatusChangePresent,
    setIsChangeApprovalStatusChangePresent,
  ] = useMenuCheck("");
  let isAutoDownload = useRef<boolean>(false);
  useEffect(() => {
    setIsChangeApprovalStatusChangePresent(
      "Change Recruitment Approval Status",
      "menu"
    );
  }, []);
  useEffect(() => {
    const downloadFile = async () => {
      if (sasTokenForDownloadFile && isAutoDownload?.current) {
        try {
          const response = await fetch(sasTokenForDownloadFile);
          if (!response.ok) {
            throw new Error("Failed to fetch file");
          }
          const blob = await response.blob();
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download =
            data?.applicant_details?.resume_upload?.file_name || "downloadFile";
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
          dispatchResetSasTokenForDownloadFile();
          isAutoDownload.current = false;
        } catch (error) {}
      }
    };
    downloadFile();
  }, [sasTokenForDownloadFile]);
  const buttonAndTextBoxDisabled =
    data?.interview_details?.interview_round_details?.filter(
      (el: InterviewRoundDetailsType) => {
        return (
          el?.interviewer?.user_id === loginData?.user_id &&
          !el?.is_feedback_submited
        );
      }
    );
  let toDayDate = getTodayDateWithTimeStamp();
  let timeCheck = false;
  if (buttonAndTextBoxDisabled?.length > 0) {
    timeCheck =
      buttonAndTextBoxDisabled[buttonAndTextBoxDisabled?.length - 1]
        ?.interview_date_and_time < toDayDate;
  }

  useEffect(() => {
    setIsUpdatePresent("Update Scheduled Upcoming Interviews Feedback", "menu");
  }, []);

  useEffect(() => {
    if (token && approvalId) {
      const finalData = { approval_id: approvalId, token };
      dispatchSingleApprovalListAction(finalData);
    }
  }, [approvalId]);

  useEffect(() => {
    setIsApprovedRedio(isApproved ? "3" : "2");
  }, [isApproved]);

  const handleSetRadioValue = (radioValue: string) => {
    setIsApprovedRedio(radioValue);
    setIsApproved && setIsApproved(radioValue === "3" ? true : false);
  };

  const handleCandidateCollapse = () => {
    setIsCandidateCollapsed(!isCandidateCollapsed);
  };
  const handleHiringCollapse = () => {
    setIsHiringCollapsed(!isHiringCollapsed);
  };

  const handleResumeDownload = () => {
    dispatchResetSasTokenForDownloadFile();
    let finalData = {
      token,
      fileUrl: data?.applicant_details?.resume_upload?.file_url
        ? data?.applicant_details?.resume_upload?.file_url
        : "",
      containerType: type === "finaccrm" ? 2 : 4,
    };
    dispatchGetTokenGenerateForDownloadAction(finalData);
    isAutoDownload.current = true;
  };

  return (
    <>
      {fetching ? (
        <Loader />
      ) : (
        <Modal
          centered
          isOpen={isOpen}
          toggle={toggle}
          size="xl"
          style={{ minWidth: "355px" }}
          backdrop="static"
        >
          <ModalHeader toggle={toggle}>
            {isInterviewApproval ? (
              "Approve or Reject Candidate Profile"
            ) : (
              <>
                {!(
                  buttonAndTextBoxDisabled &&
                  buttonAndTextBoxDisabled?.length > 0 &&
                  buttonAndTextBoxDisabled[
                    buttonAndTextBoxDisabled?.length - 1
                  ] &&
                  buttonAndTextBoxDisabled[buttonAndTextBoxDisabled?.length - 1]
                    ?.is_feedback_submited === false &&
                  timeCheck
                )
                  ? "View "
                  : "Submit "}
                Interview Feedback
              </>
            )}
          </ModalHeader>
          <ModalBody className="pl-2 pr-2" style={{ paddingLeft: "40px" }}>
            <div className="d-flex" style={{ justifyContent: "center" }}>
              <div style={{ width: "58%" }} className="pr-2">
                <p style={{ width: "fit-content" }} className="pending">
                  Level 0
                </p>

                <div className="d-flex" style={{ gap: "10%" }}>
                  <div>
                    <p className="feedBack-heading mb-1">
                      Phone Screening Date & Time
                    </p>
                    {data?.interview_details?.screening_details
                      ?.phone_screening_date_and_time ? (
                      <p className="d-flex">
                        <CalenderIcon />
                        <p className="ml-2">
                          {data?.interview_details?.screening_details
                            ?.phone_screening_date_and_time
                            ? formatDateAndTimeWithoutLocal(
                                data?.interview_details?.screening_details
                                  ?.phone_screening_date_and_time
                              )
                            : "NA"}
                        </p>
                      </p>
                    ) : (
                      "NA"
                    )}
                  </div>
                  <div>
                    <p className="feedBack-heading mb-1">Phone Screener</p>
                    {data?.interview_details?.screening_details?.phone_screener
                      ?.first_name?.length ? (
                      <div className="d-flex align-items-center">
                        <CircularAvatar
                          name={`${
                            data?.interview_details?.screening_details
                              ?.phone_screener?.first_name
                              ? data?.interview_details?.screening_details
                                  ?.phone_screener?.first_name
                              : "" +
                                " " +
                                data?.interview_details?.screening_details
                                  ?.phone_screener?.last_name
                              ? data?.interview_details?.screening_details
                                  ?.phone_screener?.last_name
                              : ""
                          }`}
                          image={
                            data?.interview_details?.screening_details
                              ?.phone_screener?.profile_pic?.file_url
                          }
                        />
                        <p className="ml-2 mb-0">
                          {data?.interview_details?.screening_details
                            ?.phone_screener?.first_name
                            ? data?.interview_details?.screening_details
                                ?.phone_screener?.first_name
                            : "" +
                              " " +
                              data?.interview_details?.screening_details
                                ?.phone_screener?.last_name
                            ? data?.interview_details?.screening_details
                                ?.phone_screener?.last_name
                            : ""}
                        </p>
                      </div>
                    ) : (
                      "NA"
                    )}
                  </div>
                </div>
                <p className="feedBack-heading mb-1">Feedback</p>
                <p>
                  {data?.interview_details?.screening_details
                    ?.screening_feedback
                    ? data?.interview_details?.screening_details
                        ?.screening_feedback
                    : "NA"}
                </p>
                <hr></hr>

                {data?.interview_details?.interview_round_details?.length > 0
                  ? data?.interview_details?.interview_round_details?.map(
                      (el: InterviewRoundDetailsType, index: number) => {
                        return (
                          <div>
                            <p
                              style={{ width: "fit-content" }}
                              className="pending"
                            >
                              Level {index + 1}
                            </p>

                            <div className="d-flex" style={{ gap: "10%" }}>
                              <div>
                                <p className="feedBack-heading mb-1">
                                  Interview Date & Time
                                </p>
                                <p className="d-flex">
                                  <CalenderIcon />
                                  <p className="ml-2">
                                    {el?.interview_date_and_time
                                      ? formatDateAndTimeWithoutLocal(
                                          el?.interview_date_and_time
                                        )
                                      : "NA"}
                                  </p>
                                </p>
                              </div>
                              <div>
                                <p className="feedBack-heading mb-1">
                                  Interviewer
                                </p>
                                <div className="d-flex align-items-center">
                                  {el?.interviewer?.first_name ? (
                                    <>
                                      {" "}
                                      <CircularAvatar
                                        name={`${
                                          el?.interviewer?.first_name +
                                          " " +
                                          el?.interviewer?.last_name
                                        }`}
                                        image={
                                          el?.interviewer?.profile_pic?.file_url
                                        }
                                      />
                                      <p className="ml-2 mb-0">
                                        {el?.interviewer?.first_name +
                                          " " +
                                          el?.interviewer?.last_name}
                                      </p>
                                    </>
                                  ) : (
                                    "NA"
                                  )}
                                </div>
                              </div>
                            </div>
                            {el?.interview_feedback ? (
                              <p className="feedBack-heading mb-1">Feedback</p>
                            ) : (
                              ""
                            )}
                            <p>{el?.interview_feedback}</p>
                            {index + 1 !==
                            data?.interview_details?.interview_round_details
                              ?.length ? (
                              <hr></hr>
                            ) : (
                              ""
                            )}
                          </div>
                        );
                      }
                    )
                  : ""}
                {!isInterviewApproval &&
                  buttonAndTextBoxDisabled &&
                  buttonAndTextBoxDisabled?.length > 0 &&
                  buttonAndTextBoxDisabled[
                    buttonAndTextBoxDisabled?.length - 1
                  ] &&
                  buttonAndTextBoxDisabled[buttonAndTextBoxDisabled?.length - 1]
                    ?.is_feedback_submited === false &&
                  timeCheck &&
                  isUpdatePresent && (
                    <>
                      <p className="feedBack-heading mb-1">
                        Add your comment here
                      </p>
                      <textarea
                        onChange={(e: any) => {
                          hanldeFeedback && hanldeFeedback(e?.target?.value);
                          setFeedback((prv: string) => e?.target?.value);
                        }}
                        style={{
                          height: "241px",
                          width: "90%",
                          resize: "none",
                          border: "1px solid #bfcbe1",
                          borderRadius: "4px",
                        }}
                      ></textarea>
                      <button
                        className="btn btn-primary mt-4"
                        onClick={(e) => {
                          handleSubmitFeedback && handleSubmitFeedback();
                        }}
                        disabled={feedback?.length === 0}
                      >
                        {isInterviewApproval && isApproved
                          ? "Approved with Comment"
                          : isInterviewApproval && !isApproved
                          ? "Reject with Comment"
                          : "Submit Feedback"}
                      </button>
                    </>
                  )}
                {isChangeApprovalStatusChangePresent &&
                isInterviewApproval &&
                singleApprovalData?.status === 1 ? (
                  <div className="mt-2 mb-4">
                    <RadioContainer
                      optionsList={RADIO_OPTIONS}
                      handleSetRadioValue={handleSetRadioValue}
                      radioValue={isApprovedRedio}
                    />
                  </div>
                ) : (
                  ""
                )}
                {isChangeApprovalStatusChangePresent &&
                isInterviewApproval &&
                singleApprovalData?.status === 1 ? (
                  <>
                    <p className="feedBack-heading mb-1">
                      Add your comment here
                    </p>
                    <textarea
                      onChange={(e: any) => {
                        hanldeFeedback && hanldeFeedback(e?.target?.value);
                        setFeedback((prv: string) => e?.target?.value);
                      }}
                      style={{
                        height: "241px",
                        width: "90%",
                        resize: "none",
                        border: "1px solid #bfcbe1",
                        borderRadius: "4px",
                      }}
                    ></textarea>
                    {isChangeApprovalStatusChangePresent && (
                      <button
                        className="btn btn-primary mt-4"
                        onClick={(e) => {
                          handleSubmitFeedback && handleSubmitFeedback();
                        }}
                        disabled={feedback?.length === 0}
                      >
                        {isInterviewApproval && isApproved
                          ? "Approved with Comment"
                          : isInterviewApproval && !isApproved
                          ? "Reject with Comment"
                          : "Submit Feedback"}
                      </button>
                    )}
                  </>
                ) : (
                  ""
                )}

                {(singleApprovalData?.status === 2 ||
                  singleApprovalData?.status === 3) &&
                isInterviewApproval ? (
                  <div
                    className="p-3"
                    style={{
                      background: "rgba(244, 246, 248, 0.91)",
                      border: "1px solid #bfcbe1",
                      borderRadius: "8px",
                    }}
                  >
                    <div style={{ fontSize: "14px", fontWeight: 500 }}>
                      Candidate Approval Details
                    </div>

                    <div className="d-flex w-100 mt-3" style={{ gap: "10%" }}>
                      <div className="mt-1 w-30">
                        <div style={{ color: "#6e7491" }}>Status</div>
                        <div
                          style={{
                            width: "fit-content",
                            borderRadius: "16px",
                            color:
                              singleApprovalData?.status === 3 ? "#82b01f" : "",
                            background:
                              singleApprovalData?.status === 3 ? "#e7f0d4" : "",
                          }}
                          className={
                            singleApprovalData?.status === 3
                              ? " credit mt-1"
                              : singleApprovalData?.status === 2
                              ? "rejected mt-1"
                              : "phoneScreening mt-1 "
                          }
                        >
                          {singleApprovalData?.status === 2
                            ? "Candidate Rejected"
                            : singleApprovalData?.status === 3
                            ? "Candidate Approved"
                            : "Pending Approval"}
                        </div>
                      </div>
                      <div className="w-50">
                        <div style={{ color: "#6e7491" }}>
                          Approved / Rejected By
                        </div>
                        <div
                          className="d-flex align-items-center mt-1"
                          style={{ gap: "3%" }}
                        >
                          <div>
                            <CustomizedAvatar
                              name={`${
                                singleApprovalData?.approved_by?.first_name +
                                " " +
                                singleApprovalData?.approved_by?.last_name
                              }`}
                              image={
                                singleApprovalData?.approved_by?.profile_pic
                                  ?.file_url
                              }
                              style={{ width: "42px", fontSize: "18px" }}
                            />
                          </div>
                          <div>
                            <p
                              className="mb-0"
                              style={{
                                fontSize: "15px",
                                fontWeight: 500,

                                cursor: "pointer",
                              }}
                            >
                              {singleApprovalData?.approved_by?.first_name +
                                " " +
                                singleApprovalData?.approved_by?.last_name}{" "}
                            </p>
                            <p
                              className="mt-0 mb-1"
                              style={{ color: "#6e7491" }}
                            >{`${singleApprovalData?.approved_by?.job_title} `}</p>
                            <div
                              style={{
                                color: "#28a745",
                                display: "flex",
                                alignItems: "center",
                                fontWeight: 500,
                              }}
                            ></div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="mt-3">
                      <div style={{ color: "#6e7491" }}>Comment</div>
                      <div className="mt-2">{singleApprovalData?.comment}</div>
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </div>
              <div style={{ width: "38%" }}>
                <div
                  style={{
                    width: "100%",
                    // height: "fit-content",
                    border: "solid 1px #bfcbe1",
                    borderRadius: "5px",
                    height: isCandidateCollapsed ? "160px" : "fit-content",
                    overflow: "hidden",
                  }}
                  className="mt-2"
                >
                  <div
                    className="p-3"
                    style={{
                      fontSize: "13px",
                      fontWeight: 600,
                      cursor: "pointer",
                    }}
                    onClick={() =>
                      loginData?.user_id == approvedUserID
                        ? handleCandidateCollapse()
                        : ""
                    }
                  >
                    <div className="d-flex justify-content-between align-items-center">
                      <div>Candidate Profile</div>
                      <div>
                        <img
                          src={
                            isCandidateCollapsed ? CollapseClose : CollapseOpen
                          }
                          alt="collapse-icon"
                        />
                      </div>
                    </div>
                  </div>
                  <hr className="m-0"></hr>
                  <div className="p-3">
                    <div
                      className="d-flex align-items-center "
                      style={{ gap: "3%" }}
                    >
                      <div>
                        <CustomizedAvatar
                          name={`${data?.applicant_details?.name}`}
                          image={data?.applicant_details?.profile_pic?.file_url}
                          style={{ width: "75px", fontSize: "25px" }}
                        />
                      </div>
                      <div>
                        <div>
                          <p
                            className="mb-1"
                            style={{ fontSize: "15px", fontWeight: 600 }}
                          >
                            {data?.applicant_details?.name}
                          </p>
                          <p className="mt-0 mb-1" style={{ color: "#6e7491" }}>
                            {data?.applicant_details?.email}
                          </p>
                          <div
                            className="mt-0 mb-1"
                            style={{ color: "#6e7491" }}
                          >
                            {data?.applicant_details?.phone_number}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="inside-card-header d-flex w-100 p-3">
                    <div
                      className="feedBack-heading d-flex align-items-center"
                      style={{ width: "50%" }}
                    >
                      <img src={IdBadge} alt="" className="mr-3" />
                      <div>Unique ID</div>
                    </div>

                    <div style={{ width: "50%" }}>
                      <span className="sent">{data?.unique_id}</span>
                    </div>
                  </div>

                  <div className="inside-card-header d-flex w-100 p-3">
                    <div
                      className="feedBack-heading d-flex align-items-center"
                      style={{ width: "50%" }}
                    >
                      <img src={BriefCase} alt="" className="mr-3" />
                      <div>Experience</div>
                    </div>
                    <div style={{ width: "50%" }}>
                      {data?.applicant_details?.years_of_experience} Years
                    </div>
                  </div>

                  <div className="inside-card-header d-flex w-100 p-3">
                    <div
                      className="feedBack-heading d-flex align-items-center"
                      style={{ width: "50%" }}
                    >
                      <img src={NoticeCalendarIcon} alt="" className="mr-3" />
                      <div>Notice Period</div>
                    </div>
                    <div style={{ width: "50%" }}>
                      {`${data?.applicant_details?.notice_period} ${
                        data?.applicant_details?.notice_period ? "Months" : "NA"
                      }`}
                    </div>
                  </div>
                  <div className="inside-card-header d-flex w-100 p-3">
                    <div
                      className="feedBack-heading d-flex align-items-center"
                      style={{ width: "50%" }}
                    >
                      <img src={LinkdionIcon} alt="" className="mr-3" />
                      <div>Linkedin Profile</div>
                    </div>
                    <div
                      style={{
                        overflowWrap: "anywhere",
                        cursor: "pointer",
                        width: "50%",
                      }}
                    >
                      {data?.applicant_details?.linkedin_profile ? (
                        <a
                          style={{
                            textDecoration: "underline",
                            color: "black",
                            cursor: "pointer",
                          }}
                          target="_blank"
                          href={data?.applicant_details?.linkedin_profile}
                        >
                          {data?.applicant_details?.linkedin_profile}
                        </a>
                      ) : (
                        "NA"
                      )}
                    </div>
                  </div>

                  <div className="inside-card-header d-flex w-100 p-3">
                    <div
                      className="feedBack-heading d-flex align-items-center"
                      style={{ width: "50%" }}
                    >
                      <img src={CVIcon} alt="" className="mr-3" />
                      <div>CV</div>
                    </div>
                    <div>
                      {data?.applicant_details?.resume_upload?.file_url ? (
                        <>
                          <PaperClipIcon />
                          <a
                            style={{
                              width: "50%",

                              color: "black",
                              cursor: "pointer",
                            }}
                            rel="noopener noreferrer"
                            target="_blank"
                            onClick={() => handleResumeDownload()}
                          >
                            {data?.applicant_details?.resume_upload?.file_name}
                          </a>
                        </>
                      ) : (
                        "NA"
                      )}
                    </div>
                  </div>

                  <div
                    style={{ fontSize: "16px", fontWeight: 500 }}
                    className="mt-3 pl-3"
                  >
                    Position Details
                  </div>

                  <div className="inside-card-header d-flex w-100 p-3">
                    <div
                      className="feedBack-heading d-flex align-items-center"
                      style={{ width: "50%" }}
                    >
                      <img src={NoticeCalendarIcon} alt="" className="mr-3" />
                      <div>Application Date</div>
                    </div>
                    <div style={{ width: "50%" }}>
                      {formatDate(data?.interview_details?.application_date)}
                    </div>
                  </div>

                  <div className="inside-card-header d-flex w-100 p-3 ">
                    <span
                      className="feedBack-heading d-flex align-items-center"
                      style={{ width: "50%" }}
                    >
                      <img src={BriefCase} alt="" className="mr-3" />
                      <div>Job Position</div>
                    </span>
                    <div style={{ width: "50%" }}>
                      {data?.position_details?.job_position?.name
                        ? data?.position_details?.job_position?.name
                        : "NA"}
                    </div>
                  </div>

                  <div className="inside-card-header d-flex w-100 p-3">
                    <span
                      className="feedBack-heading d-flex align-items-center"
                      style={{ width: "50%" }}
                    >
                      <img src={LoctionRedIcon} alt="" className="mr-3" />
                      <div>Job Location</div>
                    </span>
                    <div style={{ width: "50%" }}>
                      {data?.position_details?.job_location?.name
                        ? data?.position_details?.job_location?.name
                        : "NA"}
                    </div>
                  </div>

                  <div className="inside-card-header d-flex w-100 p-3">
                    <span
                      className="feedBack-heading d-flex align-items-center"
                      style={{ width: "50%" }}
                    >
                      <img src={InterviewStatusIcon} alt="" className="mr-3" />
                      <div>Interview Status</div>
                    </span>
                    <div style={{ width: "50%" }}>
                      <span
                        className={
                          data?.position_details?.progress === "New Application"
                            ? "newApplication"
                            : data?.position_details?.progress ===
                                "Phone Screening" ||
                              data?.position_details?.progress ===
                                "Interviewing"
                            ? "phoneScreening"
                            : data?.position_details?.progress ===
                              "Offer Pending"
                            ? "pending"
                            : data?.position_details?.progress ===
                                "Offer Rejected" ||
                              data?.position_details?.progress ===
                                "Application Rejected"
                            ? "rejected"
                            : data?.position_details?.progress ===
                                "Offer Sent" ||
                              data?.position_details?.progress ===
                                "Offer Accepted"
                            ? "sent"
                            : data?.position_details?.progress ===
                                "Accepted but Withdrawn" ||
                              data?.position_details?.progress ===
                                "Application on Hold"
                            ? "onhold"
                            : ""
                        }
                      >
                        {data?.position_details?.progress}
                      </span>
                    </div>
                  </div>

                  <div className="inside-card-header d-flex w-100 p-3 pb-4">
                    <span
                      className="feedBack-heading d-flex align-items-center"
                      style={{ width: "50%" }}
                    >
                      <img src={RecruiterHRIcon} alt="" className="mr-3" />
                      <div>Recruiter</div>
                    </span>
                    <div style={{ width: "50%" }}>
                      {data?.position_details?.recruiter?.first_name ? (
                        <>
                          <div className="d-flex align-items-center">
                            <CircularAvatar
                              name={`${
                                data?.position_details?.recruiter?.first_name +
                                " " +
                                data?.position_details?.recruiter?.last_name
                              }`}
                              image={
                                data?.position_details?.recruiter?.profile_pic
                                  ?.file_url
                              }
                            />
                            <span className="ml-2">
                              {data?.position_details?.recruiter?.first_name +
                                " " +
                                data?.position_details?.recruiter?.last_name}
                            </span>
                          </div>
                        </>
                      ) : (
                        "NA"
                      )}
                    </div>
                  </div>
                </div>

                {/* ///// */}
                {loginData?.user_id == approvedUserID ? (
                  <div
                    style={{
                      width: "100%",
                      // height: "fit-content",
                      border: "solid 1px #bfcbe1",
                      borderRadius: "5px",
                      height: isHiringCollapsed ? "62px" : "fit-content",
                      overflow: "hidden",
                    }}
                    className="mt-2"
                  >
                    <div
                      className="p-3"
                      style={{
                        fontSize: "13px",
                        fontWeight: 600,
                      }}
                      onClick={() => handleHiringCollapse()}
                    >
                      <div className="d-flex justify-content-between align-items-center">
                        <div>Hiring Details</div>
                        <div>
                          <img
                            src={
                              isHiringCollapsed ? CollapseClose : CollapseOpen
                            }
                            alt="collapse-icon"
                          />
                        </div>
                      </div>
                    </div>
                    <hr className="m-0"></hr>
                    {/* PROPOSED JOINING DATE */}
                    <div
                      className="inside-card-header d-flex w-100 p-3"
                      style={{ gap: "40px" }}
                    >
                      <div
                        className="feedBack-heading d-flex align-items-center"
                        style={{ width: "50%" }}
                      >
                        <img src={NoticeCalendarIcon} alt="" className="mr-3" />
                        <div>Proposed Joining Date</div>
                      </div>

                      <div style={{ width: "50%" }}>
                        <span>
                          {" "}
                          {data?.position_details?.proposed_joining_date
                            ? reverseDate(
                                data?.position_details?.proposed_joining_date?.split(
                                  "T"
                                )[0]
                              )
                            : "NA"}
                        </span>
                      </div>
                    </div>
                    {/* DEPARTMENT */}
                    <div
                      className="inside-card-header d-flex w-100 p-3"
                      style={{ gap: "40px" }}
                    >
                      <div
                        className="feedBack-heading d-flex align-items-center"
                        style={{ width: "50%" }}
                      >
                        <img src={GroupPeopleIcon} alt="" className="mr-3" />
                        <div>Department</div>
                      </div>

                      <div style={{ width: "50%" }}>
                        <span>
                          {data?.position_details?.department?.name
                            ? data?.position_details?.department?.name
                            : "NA"}
                        </span>
                      </div>
                    </div>
                    {/* OFFERED JOB POSITION */}
                    <div
                      className="inside-card-header d-flex w-100 p-3 "
                      style={{ gap: "40px" }}
                    >
                      <span
                        className="feedBack-heading d-flex align-items-center"
                        style={{ width: "50%" }}
                      >
                        <img src={BriefCase} alt="" className="mr-3" />
                        <div>Offered Job Position</div>
                      </span>
                      <div style={{ width: "50%" }}>
                        {data?.position_details?.offered_job_position?.name
                          ? data?.position_details?.offered_job_position?.name
                          : "NA"}
                      </div>
                    </div>

                    {/* CURRENT TOTAL CTC */}
                    <div
                      className="inside-card-header d-flex w-100 p-3"
                      style={{ gap: "40px" }}
                    >
                      <div
                        className="feedBack-heading d-flex align-items-center"
                        style={{ width: "50%" }}
                      >
                        <img src={WalletIcon} alt="" className="mr-3" />
                        <div>Current (Annual) CTC</div>
                      </div>

                      <div style={{ width: "50%" }}>
                        <span>
                          ₹{" "}
                          {data?.salary_details?.current_total_ctc
                            ? data?.salary_details?.current_total_ctc
                            : "0"}
                        </span>
                      </div>
                    </div>

                    {/* CURRENT FIXED CTC */}
                    <div
                      className="inside-card-header d-flex w-100 p-3"
                      style={{ gap: "40px" }}
                    >
                      <div
                        className="feedBack-heading d-flex align-items-center"
                        style={{ width: "50%" }}
                      >
                        <img src={WalletIcon} alt="" className="mr-3" />
                        <div>Current Fixed (Annual) CTC</div>
                      </div>

                      <div style={{ width: "50%" }}>
                        <span>
                          ₹{" "}
                          {data?.salary_details?.current_fixed_ctc
                            ? data?.salary_details?.current_fixed_ctc
                            : "0"}
                        </span>
                      </div>
                    </div>
                    {/* MINIMUM EXPECTED TOTAL CTC */}
                    <div
                      className="inside-card-header d-flex w-100 p-3"
                      style={{ gap: "40px" }}
                    >
                      <div
                        className="feedBack-heading d-flex align-items-center"
                        style={{ width: "50%" }}
                      >
                        <img src={WalletIcon} alt="" className="mr-3" />
                        <div>Minimum Expected (Annual) CTC</div>
                      </div>

                      <div style={{ width: "50%" }}>
                        <span>
                          ₹{" "}
                          {data?.salary_details?.min_expected_total_ctc
                            ? data?.salary_details?.min_expected_total_ctc
                            : "0"}
                        </span>
                      </div>
                    </div>
                    {/* MINIMUM EXPECTED FIXED CTC */}
                    <div
                      className="inside-card-header d-flex w-100 p-3"
                      style={{ gap: "40px" }}
                    >
                      <div
                        className="feedBack-heading d-flex align-items-center"
                        style={{ width: "50%" }}
                      >
                        <img src={WalletIcon} alt="" className="mr-3" />
                        <div> Minimum Expected Fixed (Annual) CTC </div>
                      </div>

                      <div style={{ width: "50%" }}>
                        <span>
                          ₹{" "}
                          {data?.salary_details?.min_expected_fixed_ctc
                            ? data?.salary_details?.min_expected_fixed_ctc
                            : "0"}
                        </span>
                      </div>
                    </div>
                    {/* OFFERED CTC */}
                    <div
                      className="inside-card-header d-flex w-100 p-3"
                      style={{ gap: "40px" }}
                    >
                      <div
                        className="feedBack-heading d-flex align-items-center"
                        style={{ width: "50%" }}
                      >
                        <img src={WalletIcon} alt="" className="mr-3" />
                        <div>Offered (Annual) CTC</div>
                      </div>

                      <div style={{ width: "50%" }}>
                        <span>
                          ₹{" "}
                          {data?.salary_details?.offered_ctc
                            ? data?.salary_details?.offered_ctc
                            : "0"}
                        </span>
                      </div>
                    </div>
                    {/* OFFERED FIXED CTC */}
                    <div
                      className="inside-card-header d-flex w-100 p-3"
                      style={{ gap: "40px" }}
                    >
                      <div
                        className="feedBack-heading d-flex align-items-center"
                        style={{ width: "50%" }}
                      >
                        <img src={WalletIcon} alt="" className="mr-3" />
                        <div>Offered Fixed (Annual) CTC</div>
                      </div>

                      <div style={{ width: "50%" }}>
                        <span>
                          ₹{" "}
                          {data?.salary_details?.offered_fixed_ctc
                            ? data?.salary_details?.offered_fixed_ctc
                            : "0"}
                        </span>
                      </div>
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </div>
              {/* //// */}
            </div>
          </ModalBody>
        </Modal>
      )}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  singleApprovalData: state.thinksToDo.singleApprovalData,
  sasTokenForDownloadFile: state.stcoTools.sasTokenForDownloadFile,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchSingleApprovalListAction: (data: SingleApprovalListPayloadType) =>
    dispatch(singleGetApprovalListAction(data)),
  dispatchResetSasTokenForDownloadFile: () =>
    dispatch(resetSasTokenForDownloadFile()),
  dispatchGetTokenGenerateForDownloadAction: (
    data: GetGenerateSasTokenPayloadType
  ) => dispatch(getTokenGenerateForDownloadAction(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FeedBackModal);
